<template>
  <div>
    <HoverShowContent :always-show="alwaysShow">
      <slot />
      <template #hover-content>
        <button :class="btnClass" @click="$emit('clicked')">
          {{ btnText }}
        </button>
      </template>
    </HoverShowContent>
  </div>
</template>

<script>
import HoverShowContent from '@/components/HoverShowContent.vue'

export default {
  components: { HoverShowContent },
  props: {
    btnClass: { type: String, default: 'btn btn-xs btn-default' },
    btnText: { type: String, default: $t('Edit') },
    alwaysShow: { type: Boolean, default: false },
  },
}
</script>
